module.exports = __webpack_public_path__ + "img/card-projeto.229367dd.svg";